import { apiSlice } from "../../app/api/apiSlice";

export const cartApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // 📋 Get current cart items
    getCart: builder.query({
      query: () => "/cart",
      providesTags: ["Cart"],
    }),

    // ➕ Add an item (Backend finds or creates the cart, checks matching variants, and increments)
    addItemToCart: builder.mutation({
      query: (itemDetails) => ({
        url: "/cart/add",
        method: "POST",
        body: itemDetails,
      }),
      invalidatesTags: ["Cart"], // 🔄 Instantly reloads the cart view automatically
    }),

    // 🔄 Update quantity directly
    updateItemQuantity: builder.mutation({
      query: (body) => ({
        url: "/cart/update-quantity",
        method: "PATCH",
        body, // e.g., { productId, size, color, quantity }
      }),
      invalidatesTags: ["Cart"],
    }),

    // ❌ Remove an entire item row
    removeItemFromCart: builder.mutation({
      query: (body) => ({
        url: "/cart/remove-item",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Cart"],
    }),
  }),
});

export const {
  useGetCartQuery,
  useAddItemToCartMutation,
  useUpdateItemQuantityMutation,
  useRemoveItemFromCartMutation,
} = cartApiSlice;
